export class AuctionwareConstants {
  static USER_REGISTRATION_PROGRESS = "USER_REGISTRATION_PROGRESS";
  static SIGNIN_IN = "SIGNIN_IN";
  static LOADER_NOTIFICATION = "LOADER_NOTIFICATION";
  static SAVING_DATA = "SAVING_DATA";
  static SUCCESS_CODE = "200";
}
